import React, { createContext, useContext, useMemo, useReducer } from "react";
import { apply, WorkspaceEvent } from "./model/engine";
import { seedWorkspace } from "./model/fixtures";
import { Workspace } from "./model/types";

interface TailSpendContextValue {
    workspace: Workspace;
    dispatch: React.Dispatch<WorkspaceEvent>;
}

const TailSpendContext = createContext<TailSpendContextValue | null>(null);

export const TailSpendProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [workspace, dispatch] = useReducer(apply, undefined, seedWorkspace);
    const value = useMemo(() => ({ workspace, dispatch }), [workspace]);
    return <TailSpendContext.Provider value={value}>{children}</TailSpendContext.Provider>;
};

export function useTailSpend(): TailSpendContextValue {
    const ctx = useContext(TailSpendContext);
    if (!ctx) throw new Error("useTailSpend must be used inside <TailSpendProvider>");
    return ctx;
}
